import api from './api';

const BASE = (id) => `/admin/seat-map-templates/${id}`;

const adminSeatMapService = {
  // ── Template list / create (admin) ────────────────────────────────────────
  listTemplates: () =>
    api.get('/admin/seat-map-templates'),

  createTemplate: (data) =>
    api.post('/admin/seat-map-templates', data),

  deleteTemplate: (id) =>
    api.delete(BASE(id)),

  // ── Methods that mirror seatMapService (same signatures, used by SeatMapEditor)
  getMap: (id) =>
    api.get(BASE(id)),

  updateMap: (id, data) =>
    api.put(BASE(id), data),

  deleteMap: (id) =>
    api.delete(BASE(id)),

  uploadBackground: (id, file) => {
    const form = new FormData();
    form.append('image', file);
    return api.post(`${BASE(id)}/background`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  saveLayout: (id, sections) =>
    api.post(`${BASE(id)}/layout`, { sections }),

  // ── Sections ──────────────────────────────────────────────────────────────
  createSection: (id, data) =>
    api.post(`${BASE(id)}/sections`, data),

  updateSection: (id, sectionId, data) =>
    api.put(`${BASE(id)}/sections/${sectionId}`, data),

  deleteSection: (id, sectionId) =>
    api.delete(`${BASE(id)}/sections/${sectionId}`),

  // ── Seats ─────────────────────────────────────────────────────────────────
  getSectionSeats: (id, sectionId) =>
    api.get(`${BASE(id)}/sections/${sectionId}/seats`),

  generateSeats: (id, sectionId, data) =>
    api.post(`${BASE(id)}/sections/${sectionId}/seats/generate`, data),

  updateSeat: (id, sectionId, seatId, data) =>
    api.put(`${BASE(id)}/sections/${sectionId}/seats/${seatId}`, data),

  deleteSeat: (id, sectionId, seatId) =>
    api.delete(`${BASE(id)}/sections/${sectionId}/seats/${seatId}`),

  batchSeats: (id, payload) =>
    api.post(`${BASE(id)}/seats/batch`, payload),

  // ── Price zones ───────────────────────────────────────────────────────────
  getPriceZones: (id) =>
    api.get(`${BASE(id)}/price-zones`),

  createPriceZone: (id, data) =>
    api.post(`${BASE(id)}/price-zones`, data),

  updatePriceZone: (id, zoneId, data) =>
    api.put(`${BASE(id)}/price-zones/${zoneId}`, data),

  deletePriceZone: (id, zoneId) =>
    api.delete(`${BASE(id)}/price-zones/${zoneId}`),

  // ── Organizer-facing ──────────────────────────────────────────────────────
  listForOrganizer: () =>
    api.get('/organizer/seat-map-templates'),

  applyToEvent: (eventId, templateId) =>
    api.post(`/organizer/events/${eventId}/seat-map/from-template/${templateId}`),
};

export default adminSeatMapService;
